import React, { useEffect, useState } from 'react';
import axios from "axios";
import styles from '../../assets/styles/HomepageOverview/Asana.module.css';
import Practice from '../../assets/images/images.jpg';
import { useParams } from 'react-router-dom';
const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const API = `${ENV_API_BASE_URL}/api/teacher-training-cards`;

const HathaYoga = () => {

  const { slug } = useParams();
  const [hoveredCard, setHoveredCard] = useState(null);
  const [benefits, setBenefits] = useState([]);
  const [poses, setPoses] = useState([]);
  const [practice, setPractice] = useState([]);
  const [heading, setHeading] = useState("Hatha Yoga");
  const [description, setDescription] = useState("Traditional Hatha Yoga focuses on foundational postures and breath awareness.");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {

      const res = await axios.get(API);
      console.log(slug,'slug is this', res.data, 'response data is this')
      const data = res.data.data || []; // first card
      const currentData = data?.find((el) => el.slug == slug);
      setHeading(currentData?.heading)
      setDescription(currentData?.paragraph)
      setBenefits(currentData?.benefits || []);
      setPoses(currentData?.traditional || []);
      setPractice(currentData?.practice || []);

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.hathaYogaPage}>

      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroOverlay}></div>
        <div className="container">
          <div className="row align-items-center min-vh-100">
            <div className="col-lg-8 mx-auto text-center">
              <div className={styles.heroBadge}>Traditional Practice</div>
              <h1 className={`display-3 fw-bold mb-4 ${styles.heroTitle}`}>
                {heading}
              </h1>

              <p className={`lead ${styles.heroDescription}`}>
                {description}
              </p>

            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className={`py-5 ${styles.benefitsSection}`}>
        <div className="container py-5">

          <div className="text-center mb-5">
            <h2 className={styles.sectionTitle}>Core Benefits</h2>
          </div>

          <div className="row g-4">

            {benefits.map((benefit, index) => (

              <div className="col-md-6 col-lg-3" key={index}>

                <div
                  className={`${styles.benefitCard} ${hoveredCard === index ? styles.active : ''}`}
                  onMouseEnter={() => setHoveredCard(index)}
                  onMouseLeave={() => setHoveredCard(null)}
                >

                  <div className={styles.benefitIcon}>
                    {benefit.icon}
                  </div>

                  <h3 className={styles.benefitTitle}>
                    {benefit.cardHeading}
                  </h3>

                  <p className={styles.benefitDescription}>
                    {benefit.cardParagraph}
                  </p>

                </div>

              </div>

            ))}

          </div>
        </div>
      </section>

      {/* Traditional Section */}

      <section className={`py-5 ${styles.posesSection}`}>
        <div className="container py-5">

          <div className="text-center mb-5">
            <h2 className={styles.sectionTitle}>Traditional Asanas</h2>
          </div>

          <div className="row g-4">

            {poses.map((pose, index) => (

              <div className="col-md-6 col-lg-4" key={index}>

                <div className={styles.poseCard}>
                  <div className={styles.poseCardInner}>

                    <div className={styles.poseNumber}>
                      {pose.number}
                    </div>

                    <h4 className={styles.poseName}>
                      {pose.heading}
                    </h4>

                    <p className={styles.poseSanskrit}>
                      {pose.title}
                    </p>

                  </div>
                </div>

              </div>

            ))}

          </div>

        </div>
      </section>

      {/* Practice Section */}

      <section className={`py-5 ${styles.practiceSection}`}>
        <div className="container py-5">

          <div className="row align-items-center">

            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className={styles.practiceImageWrapper}>
                <img src={Practice} alt="" />
              </div>
            </div>

            <div className="col-lg-6">

              <h2 className={`${styles.sectionTitle} mb-4`}>
                The Practice
              </h2>

              <div className={styles.practiceContent}>

                {practice.map((item, index) => (

                  <div className={styles.practiceItem} key={index}>

                    <div className={styles.practiceIcon}>
                      {item.cardicon}
                    </div>

                    <div>
                      <h5>{item.cardHead}</h5>
                      <p>{item.cardPara}</p>
                    </div>

                  </div>

                ))}

              </div>

            </div>

          </div>

        </div>
      </section>

    </div>
  );
};

export default HathaYoga;